/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';

import {
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    marginTop: '30px',
    marginBottom: '30px',
  },
  table: {
    width: '100%',
    minWidth: 650,
    '& .MuiTableCell-root': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  empty: {
    backgroundColor: '#f3f2f2',
  },
  content: {
    fontSize: '12px',
  },
  bold: {
    fontSize: '12px',
    fontWeight: 'bold',
  },
  disclaimer: {
    fontSize: '12px',
  },
});

const CourseContent = ({
  contentTitles, middleTest, endTest, specificSkills,
}) => {
  const classes = useStyles();
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language === 'en' ? 'EN' : 'FR');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (contentTitles && contentTitles.length > 0) {
      setLoading(false);
    }
  }, [contentTitles]);

  return (
    <>
      <TableContainer component={Paper} className={classes.root}>
        {(contentTitles !== undefined && contentTitles.length > 0 && specificSkills !== undefined && loading === false)
          && (
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center"> </TableCell>
                  <TableCell align="center">{t('courseContent.operationalSkills', 'Compétences opérationnelles')}</TableCell>
                  <TableCell align="center">{t('courseContent.languageSkills', 'Compétences linguistiques')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contentTitles.map((contentTitle) => (
                  <TableRow>
                    <TableCell align="center" variant="head">{contentTitle[language]}</TableCell>
                    {contentTitle.content !== undefined
                      && (
                        <>
                          <TableCell align="left">
                            {contentTitle.content.map((content) => (
                              <>
                                {content.type === 'functional'
                                  && (
                                    <>
                                      <Typography className={classes.content}>{content[language]}</Typography>
                                      <br />
                                    </>
                                  )}
                              </>
                            ))}
                          </TableCell>
                          <TableCell align="left">
                            {contentTitle.content.map((content) => (
                              <>
                                {content.type === 'language'
                                  && (
                                    <>
                                      <Typography className={classes.content}>{content[language]}</Typography>
                                      <br />
                                    </>
                                  )}
                              </>
                            ))}
                          </TableCell>
                        </>
                      )}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell align="center" variant="head">
                    Compétences spécifiques
                  </TableCell>
                  <TableCell colSpan={2}>
                    {specificSkills.map((specificSkill) => (
                      <>
                        <Typography className={classes.content}>{specificSkill[language]}</Typography>
                        <br />
                      </>
                    ))}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.disclaimer} colSpan={3}>
                    <Typography className={classes.bold}>Evaluation et suivi :</Typography>
                    {' '}
                    <br />
                    Contrôle régulier des connaissances et des acquis par des tests effectués par le formateur:
                    <br />
                    {middleTest && <>test intermédiaire</>}
                    <br />
                    {endTest && <>test final</>}
                    <br />
                    Bilan de fin de stage avec niveau et objectifs acquis
                    <br />
                    <br />
                    <Typography className={classes.bold}>Prérequis :</Typography>
                    <br />
                    Aucun prérequis n&apos;est nécessaire pour suivre cette formation. La formation s&apos;addresse à des personnes disposant d&apos;un niveau allant de débutant à C2.
                    <br />
                    Évaluation de la formation après 10h et en fin de stage.
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          )}
      </TableContainer>

    </>
  );
};

export default CourseContent;
